import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Title } from "../../../../stories/Title/Title";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../utils/Enum.types";
import { Button } from "../../../../stories/Button/Button";
import { useContext, useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../images/DownArrow.svg";
import TotalStudents from "../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../images/Present.svg";
import ContainsError from "../../../../images/Absent.svg";
import Validate from "../../../../images/Validate.svg";
import Info from "../../../../images/Information.svg";
import Close from "../../../../images/Close.svg";
import ReactModal from "react-modal";
import ExcelJS from "exceljs";
import {
  LoadingStyles,
  ViewPickedSubjectModalStyles,
} from "../../../../styles/ModalStyles";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  DEFAULT_TIME,
  emptyFunc,
} from "../../../../utils/constants";
import { getDownloadUrl } from "../../../../utils/DownloadFile";

import useUrlParams from "../../../../customHooks/useUrlParams";
import * as XLSX from "xlsx";
import {
  ExportItemDetailsTemplate,
  ItemDetailsImport,
  ValidateItemsDetailsForImport,
} from "../masters/items/queries/mutations";
import {
  AtsStckItemEdge,
  AtsStckItemOrderField,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
} from "../masters/items/queries/types";
import { GetItems } from "../masters/items/queries/queries";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import LoadingModal from "../../../pages/LoadingModal";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { AppContext } from "../../../../context/context";
import {
  CustomModal,
  convertToDateObject_MMDDYYYYFormat,
  removeCompleteSpace,
  removeMoreSpace,
  toIsoDate,
} from "../../../../utils/UtilFunctions";
import MessageModal from "../../../../customComponents/MessageModal";
import ExcelLoading from "../../../pages/ExcelLoading";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
import Navbar from "../../../common/layout/Navbar";
import { useNavigate } from "react-router-dom";
import useServerDateandTime from "../../../../customHooks/useServerDateandTime";
import useLabels from "../../../../customHooks/useLabels";
import { ExportItemDetailsResult, ExportItemDetailsVar } from "./queries/types";
import { ExportItemDetails } from "./queries/queries";
import {
  UpdateItemDetailsResult,
  UpdateItemDetailsVar,
} from "../masters/subsidary/junctions/itemdetails/queries/types";
import { UpdateItemDetails } from "../masters/subsidary/junctions/itemdetails/queries/mutations";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  NavType: LicenseTypes;
  bulkAlterPage: boolean;
}
interface ValidateItemsData {
  ValidateItemsForImport: boolean;
}

interface ValidateItemDetails {
  SubsidiaryName: string;
  SiteName: string;
  ItemDescription: string;
  SerialNumber: string;
  MaintainedBy: string;
}
interface ValidateItemsVars {
  token?: string;
  customerID: string | number;
  companyID: string | number;
  desc: string;
  input: ValidateItemDetails;
}
const ItemsDetailsImport = ({
  setModalFlag,
  pageType,
  NavType,
  bulkAlterPage,
}: Props) => {
  const { state, dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const [records, setRecords] = useState<any[]>([]);
  const [stdConfig, setStdConfig] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [selectedLedgers, setSelectedLedgers] = useState<AtsStckItemEdge[]>([]);
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id, company_id, siteID, sub_id } = useUrlParams();
  const [importModal, setImportModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const {
    itemLabel,
    companyLabel,
    subsidiarySiteLabel,
    junctionLabel,
    subsidiaryLabel,
    ledgerLabel,
  } = useLabels();

  const { serverDate } = useServerDateandTime();

  const [ValidateEachRow, { loading: validateLoading }] = useLazyQuery<
    ValidateItemsData,
    ValidateItemsVars
  >(ValidateItemsDetailsForImport);
  const [GetStockItems, { data, loading }] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >(GetItems);
  const { user_details } = useLoggedInUserDetails();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id) {
          GetStockItems({
            variables: {
              after: null,
              customerID: customer_id ? customer_id : 0,
              companyID: company_id ? company_id : 0,
              first: null,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemOrderField.DESC,
              },

              name: EMPTY_STRING,
              hsnCode: EMPTY_STRING,
              input: {
                query_type: ItemQueryType.All,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                ldgrID: 0,
                subsidiaryID: 0,
                isComponent: undefined,
              },
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, GetStockItems]);
  const itemsData = data && data.GetItems.edges;

  const totalRecords = useMemo(() => {
    return records.filter((record) => !record.errors).length;
  }, [records]);

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = event.target;
    setAllSelected(checked);

    if (checked) {
      setSelectedLedgers(itemsData!);
    } else {
      setSelectedLedgers([]);
    }
    setIsIndeterminate(false);
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const handleLedgerChange = (property: AtsStckItemEdge) => {
    setSelectedLedgers((prev) => {
      if (prev.some((s) => s.node.id === property.node.id)) {
        return prev.filter((s) => s.node.id !== property.node.id);
      } else {
        return [...prev, property];
      }
    });
  };
  const [ImportItemsData, { loading: mutationLoading }] = useMutation(
    ItemDetailsImport,
    {
      onError: (e) =>
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        }),
    }
  );
  const [ExportItems, { loading: AddItemLoading }] = useLazyQuery(
    ExportItemDetailsTemplate,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );

  const [exportItemDetails, { loading: ExportItemDetailsLoading }] =
    useLazyQuery<ExportItemDetailsResult, ExportItemDetailsVar>(
      ExportItemDetails,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const [updateItemDetails, { loading: updateLoading }] = useMutation<
    UpdateItemDetailsResult,
    UpdateItemDetailsVar
  >(UpdateItemDetails, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const displayFileName = (): void => {
    const inputElement = document.getElementById("input") as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById("file-name") as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split("\\").pop()!;
  };
  const downloadExcelContainsError = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("ErrorData");
    worksheet1.views = [{ state: "frozen", xSplit: 1, ySplit: 1 }];
    if (records.length === 0) {
      console.warn("No data available to create the Excel file.");
      return;
    }

    const errorColumns = ["errors"];
    const headers = Object.keys(records[0]).filter(
      (header) =>
        !["isChecked", "isValidated", "isValidatedAndError", "id"].includes(
          header
        )
    );

    errorColumns.forEach((col) => {
      if (!headers.includes(col)) {
        headers.push(col);
      }
    });
    worksheet1.columns = headers.map((header) => ({
      header,
      key: header,
      width: 20,
    }));

    const headerRow = worksheet1.getRow(1);
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    records
      .filter((record) => record?.errors)
      .forEach((entry, rowIndex) => {
        const row = worksheet1.getRow(rowIndex + 2);
        headers.forEach((header, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          cell.value = entry[header];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "StudentInfo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const handleExport = async () => {
    try {
      if (customer_id) {
        if (bulkAlterPage) {
          const { data, errors } = await exportItemDetails({
            variables: {
              customerID: customer_id,
              companyID: company_id ? company_id : 0,
              subsidiaryID: sub_id ? sub_id : 0,
              siteID: siteID ? siteID : 0,
              junctionID: 0,
              ldgrID: 0,
              itemsList: selectedLedgers.map((res) => res.node.desc),
              empID: 0,
            },
          });

          if (data && data.ExportItemDetails) {
            const res = await getDownloadUrl(data.ExportItemDetails, true);
            if (res) {
              setMessage({
                flag: true,
                message: "Downloading...",
                operation: Operation.CREATE,
              });
            }
          } else {
            setMessage({
              flag: true,
              message: "Failed downloading file",
              operation: Operation.NONE,
            });
          }
        } else {
          const { data, errors } = await ExportItems({
            variables: {
              customerID: customer_id,
              itemsList: selectedLedgers.map((res) => res.node.desc),
            },
          });

          if (data && data.ExportItemDetailsTemplate) {
            const res = await getDownloadUrl(
              data.ExportItemDetailsTemplate,
              true
            );
            if (res) {
              setMessage({
                flag: true,
                message: "Downloading...",
                operation: Operation.CREATE,
              });
            }
          } else {
            setMessage({
              flag: true,
              message: "Failed downloading file",
              operation: Operation.NONE,
            });
          }

          if (errors && errors.length > 0) {
            setMessage({
              flag: true,
              message: errors[0].message,
              operation: Operation.NONE,
            });
          }
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  const handleAddItems = async () => {
    setSuccessCount(0);
    setErrorCount(0);
    setImportModal(true);
    try {
      for (const record of records.filter((record) => !record.errors)) {
        try {
          const propertyData: Record<string, string> = {};
          dynamicKeys.forEach((key, index) => {
            if (record[key]) {
              propertyData[`propertyData${index + 1}`] = removeMoreSpace(
                `${key}:${record[key]}`
              );
            }
          });
          const input = {
            Alias: removeMoreSpace(record.Alias),
            SubsidiaryName: removeMoreSpace(
              record[`${removeCompleteSpace(subsidiaryLabel)}`]
            ),
            SerialNumber: removeMoreSpace(record.SerialNumber),
            BatchNumber: removeMoreSpace(record.BatchNumber),
            Brand: removeMoreSpace(record.Brand),
            Model: removeMoreSpace(record.Model),
            ExpiryDate: record.ExpiryDate
              ? toIsoDate(convertToDateObject_MMDDYYYYFormat(record.ExpiryDate))
              : toIsoDate(DEFAULT_TIME),
            MaintainedBy: removeMoreSpace(record.MaintainedBy),
            WarrantyStartDate: record.WarrantyStartDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.WarrantyStartDate)
                )
              : toIsoDate(DEFAULT_TIME),
            WarrantyEndDate: record.WarrantyEndDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.WarrantyEndDate)
                )
              : toIsoDate(DEFAULT_TIME),
            InstallationDate: record.InstallationDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.InstallationDate)
                )
              : toIsoDate(DEFAULT_TIME),
            AMCStartDate: record.AMCStartDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.AMCStartDate)
                )
              : toIsoDate(DEFAULT_TIME),
            AMCEndDate: record.AMCEndDate
              ? toIsoDate(convertToDateObject_MMDDYYYYFormat(record.AMCEndDate))
              : toIsoDate(DEFAULT_TIME),
            GeoLocation: record.GeoLocation,
            InsuranceStartDate: record.InsuranceStartDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.InsuranceStartDate)
                )
              : toIsoDate(DEFAULT_TIME),
            InsuranceEndDate: record.InsuranceEndDate
              ? toIsoDate(
                  convertToDateObject_MMDDYYYYFormat(record.InsuranceEndDate)
                )
              : toIsoDate(DEFAULT_TIME),
            ItemDescription: removeMoreSpace(
              record[`${removeCompleteSpace(itemLabel)}`]
            ),
            SiteName: removeMoreSpace(
              record[`${removeCompleteSpace(subsidiarySiteLabel)}`]
            ),
            JunctionName: removeMoreSpace(
              record[`${removeCompleteSpace(junctionLabel)}`]
            ),
            poleNum: record.PoleNum,
            Address: removeMoreSpace(record.Address),
            ...propertyData,
          };
          if (bulkAlterPage) {
            if (record.GeoLocation) {
              propertyData.prodLatitude = record.GeoLocation.split(",")[0];
              propertyData.prodLongitude = record.GeoLocation.split(",")[1];
            }
            updateItemDetails({
              variables: {
                user_details,
                customerID: customer_id!,
                itemDetailsID: record.ID,
                input: {
                  alias: removeMoreSpace(record.Alias),
                  prodSerialNo: removeMoreSpace(record.SerialNumber),
                  prodBatchNo: removeMoreSpace(record.BatchNumber),
                  prodBrand: removeMoreSpace(record.Brand),
                  prodModel: removeMoreSpace(record.Model),
                  prodExpiryDate: record.ExpiryDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(record.ExpiryDate)
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodWarrantyStartDate: record.WarrantyStartDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(
                          record.WarrantyStartDate
                        )
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodWarrantyEndDate: record.WarrantyEndDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(
                          record.WarrantyEndDate
                        )
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodInstallationEndDate: record.InstallationDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(
                          record.InstallationDate
                        )
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodAmcStDate: record.AMCStartDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(record.AMCStartDate)
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodAmcEndDate: record.AMCEndDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(record.AMCEndDate)
                      )
                    : toIsoDate(DEFAULT_TIME),

                  prodInsuranceStDate: record.InsuranceStartDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(
                          record.InsuranceStartDate
                        )
                      )
                    : toIsoDate(DEFAULT_TIME),
                  prodInsuranceEndDate: record.InsuranceEndDate
                    ? toIsoDate(
                        convertToDateObject_MMDDYYYYFormat(
                          record.InsuranceEndDate
                        )
                      )
                    : toIsoDate(DEFAULT_TIME),
                  poleNum: record.PoleNum,
                  address: removeMoreSpace(record.Address),
                  prodLatitude: propertyData.prodLatitude,
                  prodLongitude: propertyData.prodLongitude,
                  propertyData1: propertyData.propertyData1,
                  propertyData2: propertyData.propertyData2,
                  propertyData3: propertyData.propertyData3,
                  propertyData4: propertyData.propertyData4,
                  propertyData5: propertyData.propertyData5,
                  propertyData6: propertyData.propertyData6,
                  propertyData7: propertyData.propertyData7,
                  propertyData8: propertyData.propertyData8,
                  propertyData9: propertyData.propertyData9,
                  propertyData10: propertyData.propertyData10,
                },
              },
            }).then(({ data }) => {
              if (data) {
                setSuccessCount((prev) => prev + 1);
              }
            });
          } else {
            await ImportItemsData({
              variables: {
                customerID: customer_id!,
                companyID: company_id!,
                todaysDate: toIsoDate(serverDate),
                user_details,
                SubsidaryID: state.subsidiaryId,
                input,
              },
            }).then(({ data }) => {
              if (data) {
                setSuccessCount((prev) => prev + 1);
              }
            });
          }
        } catch (error) {
          console.error(error);
          setErrorCount((prev) => prev + 1);
        }
      }
    } catch (err) {
      console.error("Error fetching token:", err);
      setMessage({
        flag: true,
        message: (err as Error).message || "Failed to fetch token",
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    setIsIndeterminate(
      selectedLedgers.length > 0 && selectedLedgers.length < itemsData?.length!
    );
    setAllSelected(selectedLedgers.length === itemsData?.length!);
  }, [selectedLedgers]);

  const item_schema = {
    [`${removeCompleteSpace(subsidiaryLabel)}`]: {
      Headers: `${removeCompleteSpace(subsidiaryLabel)}`,
      key: "SubsidiaryName",
      width: 50,
      required: false,
      use_in_sheet: true,
    },

    [`${removeCompleteSpace(itemLabel)}`]: {
      Headers: `${removeCompleteSpace(itemLabel)}`,
      key: "ItemDescription",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    alias: {
      Headers: "alias",
      key: "alias",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    SerialNumber: {
      Headers: "SerialNumber",
      key: "SerialNumber",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    BatchNumber: {
      Headers: "BatchNumber",
      key: "BatchNumber",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Brand: {
      Headers: "Brand",
      key: "Brand",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Model: {
      Headers: "Model",
      key: "Model",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    poleNum: {
      Headers: "PoleNum",
      key: "poleNum",
      width: 50,
      required: false,
      use_in_sheet: true,
    },

    ExpiryDate: {
      Headers: "ExpiryDate",
      key: "ExpiryDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    MaintainedBy: {
      Headers: "MaintainedBy",
      key: "MaintainedBy",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    WarrantyStartDate: {
      Headers: "WarrantyStartDate",
      key: "WarrantyStartDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    WarrantyEndDate: {
      Headers: "WarrantyEndDate",
      key: "WarrantyEndDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    InstallationDate: {
      Headers: "InstallationDate",
      key: "InstallationDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    AMCStartDate: {
      Headers: "AMCStartDate",
      key: "AMCStartDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    AMCEndDate: {
      Headers: "AMCEndDate",
      key: "AMCEndDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    GeoLocation: {
      Headers: "GeoLocation",
      key: "GeoLocation",
      width: 50,
      required: false,
      use_in_sheet: true,
    },

    InsuranceStartDate: {
      Headers: "InsuranceStartDate",
      key: "InsuranceStartDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    InsuranceEndDate: {
      Headers: "InsuranceEndDate",
      key: "InsuranceEndDate",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Address: {
      Headers: "Address",
      key: "Address",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const excludeKeys = ["id", "isChecked", "isValidated", "isValidatedAndError"];
  const predefinedKeys = Object.keys(item_schema);

  const dynamicKeys = Array.from(
    new Set(
      records.flatMap((record) =>
        Object.keys(record).filter(
          (key) => !predefinedKeys.includes(key) && !excludeKeys.includes(key)
        )
      )
    )
  );
  const allKeys = [
    ...predefinedKeys.filter((key) => !excludeKeys.includes(key)),
    ...dynamicKeys,
  ];
  const processExcel = (data: any) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const allRecords: any[] = [];

    workbook.SheetNames.forEach((sheetName) => {
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      sheetData.forEach((record: any) => {
        let errors: any = [];
        Object.keys(item_schema).forEach((key) => {
          // @ts-ignore
          const keySchema = item_schema[key];
          const keyValue = record[key];

          if (
            keySchema?.required &&
            (keyValue === null || keyValue === undefined)
          ) {
            const errorObj = {
              column: key,
              error: "Required",
            };
            errors.push(errorObj);
          }
        });

        if (errors.length > 0) {
          record.errors = errors;
        }
        allRecords.push(record);
      });
    });

    return allRecords;
  };

  useEffect(() => {
    const input = document.getElementById("input") as HTMLInputElement;
    if (input) {
      input.addEventListener("change", () => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const res = processExcel(reader.result);
          setRecords(
            res.map((f: any, index: number) => {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            })
          );
        };
        reader.readAsBinaryString(input.files![0]);
      });
    }
  }, []);
  const handleButtonClick = async () => {
    try {
      await Promise.all(records.map((record) => handleClick(record.id)));
    } catch (error) {
      console.error(error);
    }
  };

  const handleClick = async (id: number) => {
    try {
      const filteredData = records.find((record) => record.id === id);

      if (filteredData) {
        const { data, errors } = await ValidateEachRow({
          variables: {
            customerID: customer_id!,
            companyID: company_id!,

            desc: removeMoreSpace(
              filteredData[`${removeCompleteSpace(itemLabel)}`]
            ),
            input: {
              ItemDescription: removeMoreSpace(
                filteredData[`${removeCompleteSpace(itemLabel)}`]
              ),
              SiteName: removeMoreSpace(
                filteredData[`${removeCompleteSpace(subsidiarySiteLabel)}`]
              ),
              SerialNumber: removeMoreSpace(filteredData.SerialNumber),
              SubsidiaryName: removeMoreSpace(
                filteredData[`${removeCompleteSpace(subsidiaryLabel)}`]
              ),
              MaintainedBy: removeMoreSpace(filteredData.MaintainedBy),
            },
          },
        });

        if (data) {
          const newData = records.map((record) => {
            if (id === record.id) {
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: !record.isValidated,
                isValidatedAndError: false,
              };
            }
            return record;
          });
          setRecords(newData);
          return Promise.resolve(data);
        }

        if (errors && errors.length > 0) {
          const newData = records.map((record) => {
            if (record.id === id) {
              record.errors = record.errors ? record.errors : [];
              record.errors.push(errors[0]?.message);
              return {
                ...record,
                isChecked: !record?.isChecked,
                isValidated: true,
                isValidatedAndError: true,
              };
            }
            return record;
          });
          setRecords(newData);
          return Promise.reject(errors[0]);
        }
      }
    } catch (err) {
      // Handle token or other unexpected errors
      setMessage({
        flag: true,
        message: (err as Error).message || "An error occurred",
        operation: Operation.NONE,
      });
      return Promise.reject(err);
    }
  };

  return (
    <>
      {pageType === PageFor.GENERAL ? (
        <>
          <Navbar NavType={NavType} />
          <Title>
            {bulkAlterPage ? "Bulk Alter" : "Import"} {itemLabel} Details
          </Title>
        </>
      ) : null}
      <div
        className={`import-excel-data${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        {pageType === PageFor.MODAL && (
          <div className="import-excel-data--title">
            <Title>
              {bulkAlterPage ? "Bulk Alter" : "Import"} {itemLabel} Details
            </Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
        )}

        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {itemLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter((record) => !record.errors).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter((record) => record?.errors).length}
            </span>
          </div>
        </div>

        <div
          className={`import-excel-data__datablock${
            pageType === PageFor.GENERAL ? "--general" : ""
          }`}
        >
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter((record) => !record.errors).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">SLNO</TableCell>
                        {allKeys.map((key, index) => (
                          <TableCell key={index}>{key}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter((record) => !record?.errors)
                        .map((record, index) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {allKeys.map((key, colIndex) => (
                              <TableCell key={colIndex}>
                                {key in record ? record[key] : "-"}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter((d) => d?.errors).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>
                          {allKeys
                            .filter((key) =>
                              records.some((record) => key in record)
                            )
                            .map((key, index) => (
                              <TableCell key={index}>{key}</TableCell>
                            ))}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter((record) => record?.errors)
                          .map((record, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {allKeys
                                  .filter((key) => key in record)
                                  .map((key, colIndex) => (
                                    <TableCell key={colIndex}>
                                      {record[key]}
                                    </TableCell>
                                  ))}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record && record.errors
                                          ? record?.errors?.map(
                                              (error: any, index: number) => {
                                                return (
                                                  <li key={index}>
                                                    {index + 1})&nbsp;
                                                    {typeof error === "string"
                                                      ? error
                                                      : "Error message = " +
                                                        error.error +
                                                        ", column = " +
                                                        error.column}
                                                  </li>
                                                );
                                              }
                                            )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() => {
                setImportModal(true);
                handleAddItems();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import
            </Button>
            <Button onClick={handleButtonClick}>
              <img src={Validate} alt="" />
              Validate
            </Button>
            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            {pageType === PageFor.GENERAL ? (
              <Button mode="back" onClick={() => navigate(-1)} />
            ) : (
              <Button mode="cancel" onClick={() => setModalFlag(false)} />
            )}
          </div>
          <div className="col import-excel-data__button">
            <Button
              mode="excel"
              onClick={() => {
                setStdConfig(true);
              }}
            >
              Generate Template XLS File
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal(!importModal)}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={loading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      <LoadingModal
        flag={
          validateLoading ||
          mutationLoading ||
          loading ||
          AddItemLoading ||
          ExportItemDetailsLoading ||
          updateLoading
        }
      />

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={stdConfig}
        style={ViewPickedSubjectModalStyles}
        ariaHideApp={false}
      >
        <div className="import-excel-data__receipts">
          <div className="import-excel-data__receipts--title">
            <Title>Choose Properties</Title>
            <img
              src={Close}
              alt="/"
              className="modal-close-icon"
              onClick={() => setStdConfig(!stdConfig)}
            />
          </div>

          <div className="import-excel-data__receipts--block">
            <div className="select-all">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="allSelect"
                      className="select-all--checkbox"
                      checked={allSelected}
                      indeterminate={isIndeterminate}
                      onChange={handleSelectAllChange}
                    />
                  }
                  label="Select All"
                />
              </FormGroup>
            </div>

            {itemsData &&
              itemsData.map((property, index) => (
                <FormGroup className="select-all__checkboxes" key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={property.node.desc}
                        checked={selectedLedgers.some(
                          (s) => s.node.id === property.node.id
                        )}
                        onChange={() => handleLedgerChange(property)}
                      />
                    }
                    label={
                      <>
                        &nbsp; {index + 1}) &nbsp; {property.node.desc}
                      </>
                    }
                  />
                </FormGroup>
              ))}
          </div>

          <Button mode="excel" onClick={handleExport}>
            Download To Excel
          </Button>
          <Button mode="cancel" onClick={() => setStdConfig(!stdConfig)} />
        </div>
      </ReactModal>
    </>
  );
};

export default ItemsDetailsImport;
